import { getEventBaseUrl } from "utils/getBaseUrl";

const FALLBACK_FRIENDLY_NAME = "presentation";

export const getOfflineEventPath = ({
  eventId,
  linkId,
  view = false,
}: { eventId: string; linkId?: string | null; view?: boolean }) => {
  const params = new URLSearchParams();
  if (linkId) params.set("linkId", linkId);
  const query = params.toString();
  return `/event-details/${encodeURIComponent(eventId)}/${view ? "view" : "docs"}${query ? `?${query}` : ""}`;
};

interface OfflinePresentationPathOptions {
  friendlyName?: string;
  presentationId: string;
  view?: boolean;
}

export const getOfflinePresentationPath = ({
  friendlyName,
  presentationId,
  view = false,
}: OfflinePresentationPathOptions) => {
  const friendlySegment = encodeURIComponent(
    friendlyName?.trim() || FALLBACK_FRIENDLY_NAME,
  );
  const presentationSegment = encodeURIComponent(presentationId);

  return `/docs/${friendlySegment}/${presentationSegment}${view ? "/view" : ""}`;
};

interface OfflinePresentationPublicUrlOptions {
  friendlyName?: string;
  presentationId: string;
  resourceType: number | string;
  eventId?: string | null;
  linkId?: string | null;
}

// Builds the absolute public access URL for a presentation / shared-playlist
// link. NOTE: we always compose this ourselves (rather than using the backend's
// `linkQuery`) because linkQuery serializes resourceType as the string enum
// ("Presentation"), whereas the public access page parses it with Number().
export const getOfflinePresentationPublicUrl = ({
  friendlyName,
  presentationId,
  resourceType,
  eventId,
  linkId,
}: OfflinePresentationPublicUrlOptions) => {
  const base = getEventBaseUrl();
  const protocol = base.includes("localhost") ? "http" : "https";
  if (Number(resourceType) === 0) {
    return `${protocol}://${base}${getOfflineEventPath({ eventId: presentationId, linkId })}`;
  }
  const params = new URLSearchParams({ resourceType: String(resourceType) });
  if (eventId) params.set("eventId", eventId);
  if (linkId) params.set("linkId", linkId);
  const path = getOfflinePresentationPath({ friendlyName, presentationId });
  return `${protocol}://${base}${path}?${params.toString()}`;
};
